import { styled } from '@mui/material';
import { CdaColor, colors } from 'constants/colors';

export const StatusContainer = styled('div')({
  height: '40px',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  marginTop: -15,
  '& p': {
    fontSize: '12px',
    whiteSpace: 'no-wrap',
    width: '100%',
  },
});

export const CardImage = styled('div')({
  height: '155px',
  minWidth: '95px',
  borderRadius: '13px',
  backgroundColor: colors.GREY,
  position: 'relative',
  overflow: 'hidden',
  marginRight: '10px',
  '& img': {
    height: '100%',
    width: '100%',
    objectFit: 'cover',
    objectPosition: 'center center',
  },
});

export const CardImageLabel = styled('div')(({ cda }) => ({
  height: '26px',
  width: '26px',
  borderRadius: '100%',
  position: 'absolute',
  /* backgroundColor: colors.LIGHTYELLOW, */
  backgroundColor: cda && CdaColor[cda].labelColor,
  bottom: '10px',
  right: '10px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  border: `1px solid ${cda && CdaColor[cda].labelColor}`,
  '& label': {
    fontSize: '8px',
    fontWeight: 'bold',
  },
}));

export const Status = styled('div')(({ color }) => ({
  height: '11px',
  width: '11px',
  borderRadius: '100%',
  backgroundColor: color,
  marginRight: '5px',
}));

export const CardContent = styled('div')({
  // cursor: 'pointer',
  //  height: 'calc(100% - 40px)',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  marginBottom: '16px',
  '& span': {
    fontSize: '14px',
    fontWeight: 'medium',
    lineHeight: '16px',
    margin: '0',
  },
});

export const CardText = styled('div')({
  height: '100%',
  // width: 'calc(100% - 90px)',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-evenly',
  '& h2': {
    fontSize: '24px',
    margin: '2px 0 5px 0',
    lineHeight: '27px',
  },
});

export const CardPosisiton = styled('div')({
  height: '20px',
  width: '100%',
  display: 'flex',
  marginBottom: '14px',
  '& span': {
    display: 'flex',
    alignItems: 'center',
    '& img': {
      height: '20px',
      marginRight: '8px',
    },
  },
});
